import styled from 'styled-components';

const SectionContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  min-width: 320px;
  width: 100%;
  margin: 0 auto;
  padding-left: 25px;
  padding-right: 25px;
  
  @media(min-width: 700px) {
    padding-left: 40px;
    padding-right: 40px;
  }
  
  @media(min-width: 1024px) {
    max-width: 1210px;
  }
`;

export default SectionContainer;
